import { createSelector } from '@ngrx/store';

import { selectPreferencesState } from './preferences.selectors';
import { favouriteAdapter } from '../adapters';

export const selectFavouritesState = createSelector(
  selectPreferencesState,
  (preferencesState) => preferencesState.favourites
);

export const selectFavouritesLoading = createSelector(selectFavouritesState, (artistState) => artistState.loading);

export const selectCanLoadMoreFavourites = createSelector(selectFavouritesState, (artistState) => artistState.nextPage);

export const selectFavourites = createSelector(selectFavouritesState, favouriteAdapter.getSelectors().selectAll);
